// ポップアップのTurbolinksイベントをハンドリングする関数
export function handlePopupTurbolinks() {
    document.addEventListener('turbolinks:load', () => {
        setupPopupHandler();
    });

    document.addEventListener('turbolinks:before-cache', () => {
        teardownPopupHandler();
    });
}

// ポップアップの領域外クリック時にポップアップを閉じるイベントを設定する関数
function setupPopupHandler() {
    $(document).on('click.popupHandler', function (e) {
        if (!$(e.target).closest('#popup').length) {
        $('#popup').fadeOut();
        }
    });
}

// ポップアップのクリックイベントを解除する関数
function teardownPopupHandler() {
    $(document).off('click.popupHandler');
}
